import React, { useContext } from "react";

import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
} from "@mui/material";

import { Contract } from "@safetyculture/s12-apis-connect-web/s12/subscriptions/v1/contracts_pb";

import mainStyles from "../../../styles";
import ContractRecord from "./components/org-contract-record";
import { ContractsListContext } from "context/organisation-context";

const OrgContractTab = ({}) => {
  const classes = mainStyles();
  const { contractsList } = useContext(ContractsListContext);

  const contractHeadings: Array<{ title: string; key: string }> = [
    { title: "", key: "contract-heading-expand" },
    { title: "ID", key: "contract-heading-id" },
    { title: "Status", key: "contract-heading-status" },
    { title: "Term (months)", key: "contract-heading-terms" },
    {
      title: "Start Date",
      key: "contract-heading-start-date",
    },
    {
      title: "End Date",
      key: "contract-heading-end-date",
    },
    {
      title: "Has Enterprise?",
      key: "contract-heading-has-enterprise",
    },
    {
      title: "Has Master Service Agreement?",
      key: "contract-heading-has-master-service-agreement",
    },
    {
      title: "Metadata",
      key: "contract-heading-metadata",
    },
    {
      title: "Actions",
      key: "contract-heading-actions",
    },
  ];

  const displayComponentHeadings = () => {
    return contractHeadings?.map(({ title, key }) => (
      <TableCell key={key}>
        <b>{title}</b>
      </TableCell>
    ));
  };

  const populateContracts = () => {
    if (contractsList.contracts?.length == 0) {
      return (
        <TableRow>
          <TableCell
            colSpan={contractHeadings?.length}
            data-testid={"contracts-no-results"}
          >
            <b>{"No contracts found."}</b>
          </TableCell>
        </TableRow>
      );
    }
    return contractsList.contracts?.map((contract: Contract) => (
      <ContractRecord
        key={contract.id}
        contract={contract}
        contractsTabColSpan={contractHeadings.length}
      />
    ));
  };

  return (
    <Grid container sx={classes.paddingTopSmall}>
      <TableContainer component={Paper}>
        <Table aria-label="contract-list-table">
          <TableHead>
            <TableRow>{displayComponentHeadings()}</TableRow>
          </TableHead>
          <TableBody>{populateContracts()}</TableBody>
          <TableFooter />
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default OrgContractTab;
